export type TStepEvent = 'next' | 'prev';

export type TFormatBoughtInCar = {
  stock: number;
  precio: number;
  quantityInCart: number;
  netPrice: number;
  purchasePrice: number;
  profitMargin: number;
};
export interface IEventSale {
  action: TStepEvent;
  data: unknown;
}

export enum VoucherType {
  BOLETA = 1,
  FACTURA = 2,
  'NOTA VENTA' = 3,
  'NOTA CREDITO' = 4,
  'NOTA CREDITO BOLETA' = 5
}

export enum PaymentMethodType {
  EFECTIVO = 1,
  TARJETA = 2,
  BILLETERA = 3,
  BANCO = 4
}

export enum OperationType {
  TRASLADO_INTERNO = 7,
  COMPRA = 8,
  VENTA = 9,
  REPARTO_INICIAL = 10,
  GRUPO_NOTA_VENTA = 11,
  ACTUALIZACION_STOCK_FARMACIA = 12
}
